/*
 * @Description: 中东内外场
 * @Author: gaolei
 * @Date: 2025-05-29
 * @LastEditTime: 2025-05-29 15:21:00
 * @LastEditors: gaolei
 * 中东内外场
    zd_outfield_app 
    zd_infield_app
 */

import { useAuthStore } from '@/stores/login'
import 'vant/lib/index.css'
import dsBridge from 'dsbridge'
import { loading } from '@/utils/loading'
import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'
import CryptoJS from 'crypto-js'
import router from '@/router'
import { useUsersStore } from '@/stores/users'

// 判断是否是Native App内嵌沙滩说
export const isSandsTalkMiddleEastApp = window.navigator.userAgent.indexOf('middleEastField') > -1

// 新增：动态设置 viewport 缩放
function updateViewportScale(scale: number) {
  try {
    const meta = document.querySelector('meta[name="viewport"]') as HTMLMetaElement | null
    if (!meta) return
    let content = meta.getAttribute('content') || ''
    // 统一三个缩放参数
    content = content
      .replace(/initial-scale=\d+(\.\d+)?/i, `initial-scale=${scale}`)
      .replace(/maximum-scale=\d+(\.\d+)?/i, `maximum-scale=${scale}`)
      .replace(/minimum-scale=\d+(\.\d+)?/i, `minimum-scale=${scale}`)
    // 若不存在对应字段则补齐
    if (!/initial-scale=/i.test(content)) content += `,initial-scale=${scale}`
    if (!/maximum-scale=/i.test(content)) content += `,maximum-scale=${scale}`
    if (!/minimum-scale=/i.test(content)) content += `,minimum-scale=${scale}`
    meta.setAttribute('content', content)
  } catch (e) {
    // 静默处理
  }
}

// 模块加载即执行一次，确保所有页面生效

// 在项目中创建一个全局声明文件（如：global.d.ts）
declare global {
  interface Window {
    jtJsBridge?: {
      jtH5CallNativeApi: (request: any, callback: (responseData: any) => void) => void
    }
  }
}

const callNative = async (request: { method: string; data?: any }): Promise<any> => {
  return new Promise((resolve, reject) => {
    dsBridge.call('jtH5CallNativeApi', request, (responseData) => {
      if (responseData && typeof responseData === 'string') {
        try {
          const parsedResponse = JSON.parse(responseData)
          resolve(parsedResponse)
        } catch (error) {
          resolve(responseData)
        }
      } else {
        resolve(responseData)
      }
    })
  })
}

// 获取签名
function getSign(params: any, secret: any, timestamp: any) {
  const paramsJson = params ? JSON.stringify(params, Object.keys(params).sort()) : 'N_V'
  const stringToSign = `${paramsJson}\n${timestamp}\n${secret}`

  // 将 stringToSign 直接作为 HMAC 密钥使用，确保与 Java 逻辑一致
  const hmac = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, CryptoJS.enc.Utf8.parse(stringToSign))
  const signData = hmac.finalize(CryptoJS.lib.WordArray.create([]))

  // 返回 Base64 编码的签名
  return CryptoJS.enc.Base64.stringify(signData)
}

export const sandsTalkMiddleEastOutfieldLogin = async () => {
  loading.show()
  try {
    const request = { method: 'InitForShatanChannel', data: {} }
    // 假设 callNative 返回的就是如下对象
    const res = await callNative(request)
    let getUserInfor = JSON.parse(res.data)

    let appId = ''
    let signSecret = ''
    let appUniqueId = ''
    let language = ''
    let identifierType = ''

    language = getLangKey(getUserInfor.lang) || 'en-us'
    localStorage.setItem('lang', getLangKey(getUserInfor.lang) || 'en-us')
    // 准备请求参数
    const timestamp = Date.now()
    if (getUserInfor.source === 'me_inside_app') {
      // 中东内场：将 viewport 缩放改为 0.8
      updateViewportScale(0.85)
      appId = 'zd_infield_app' // 由沙滩说提供
      signSecret = 'xC46vq1eDfR1SI2jR' // 由沙滩说提供
      appUniqueId = 'zd_infield_app'
      identifierType = 'account'
      // 存储原生给的用户信息数据到 localStorage
      localStorage.setItem('SandsTalkMiddleEastUserInfo', JSON.stringify(getUserInfor))
    } else if (getUserInfor.source === 'me_outfield_app') {
      appId = 'zd_outfield_app' // 由沙滩说提供
      signSecret = '8yyuskTDJiiJA8GYLH3'
      appUniqueId = 'zd_outfield_app'
      identifierType = 'account'
      // 存储原生给的用户信息数据到 localStorage
      localStorage.setItem('SandsTalkMiddleEastUserInfo', JSON.stringify(getUserInfor))
    }

    const noce = uuidv4()

    const params = {
      appId,
      identifierType: identifierType || '',
      identifierValue: getUserInfor.identifierValue || '',
      noce,
      timestamp,
    }

    // 生成签名
    const sign = getSign(params, signSecret, timestamp)

    // 构造最终的请求数据
    const finalRequestData = {
      appId,
      identifierType: identifierType || '',
      identifierValue: getUserInfor.identifierValue || '',
      noce,
      sign,
      timestamp,
    }

    // 发送请求
    try {
      const { data } = await axios.post(
        `${process.env.VUE_APP_API_URL}/sands-user/api/v1/auth/authorization-token`,
        JSON.stringify(finalRequestData),
        {
          headers: {
            'Content-Type': 'application/json',
            'accept-language': language
          }
        }
      )

      if (data.code === 1) {
        loading.hide()
        const authStore = useAuthStore()
        authStore.setAccessToken(data.data.access_token)
        localStorage.setItem('sandsTalkToken', data.data.access_token)
        localStorage.setItem('sandsTalkTenantId', data.data.tenantId || '1000')
        const usersStore = useUsersStore()
        const { setCollegeId } = usersStore
        setCollegeId(data.data.collegeId)
        if (getUserInfor.sourceType === 'training') {
          router.replace('/myTraining')
        } else {
          router.replace('/')
        }
        return data.data.access_token
      } else {
        const authStore = useAuthStore()
        authStore.setAccessToken('')
        localStorage.removeItem('sandsTalkToken')
        loading.hide()
        middleEastOutFieldShowToast(data.msg)
        middleEastOutFieldCloseWebview()
      }
    } catch (error) {
      const authStore = useAuthStore()
      authStore.setAccessToken('')
      localStorage.removeItem('sandsTalkToken')
      loading.hide()
      middleEastOutFieldShowToast(error + '')
      middleEastOutFieldCloseWebview()
    }
  } catch (error) {
    const authStore = useAuthStore()
    authStore.setAccessToken('')
    localStorage.removeItem('sandsTalkToken')
    loading.hide()
    middleEastOutFieldCloseWebview()
    console.error('获取Token失败:', error)
    return {}
  }
}

// 下载H5链接  (文件下载)
export const sandsTalkMiddleEastNativeLauncherUrl = (url: string, name: string) => {
  const request = { method: 'OpenFileChannel', data: { url, name } }
  callNative(request)
}

// 外场关闭webview
export const middleEastOutFieldCloseWebview = async () => {
  const request = { method: 'FinishPageChannel' }
  await callNative(request)
}

// 显示toast提示
export const middleEastOutFieldShowToast = (message: string) => {
  const request = { method: 'ToastChannel', data: { message } }
  callNative(request)
}

// 外场打开新页面
export const middleEastOutFieldNativeUrl = async (url: string) => {
  dsBridge.call('goToNativeLoadUrl', url)
}

export const middleEastOutFieldSetHoriVerti = (isFull: boolean) => {
  const request = { method: 'nativeSetHoriVerti', data: { isFull } }
  callNative(request)
}

// 外场销毁页面，返回上一页
export const registerPreviousH5 = async () => {
  dsBridge.register('previous', function (result: any) {
    const isApp = router.currentRoute.value.meta?.isMeOutFieldApp
    if (isApp) {
      middleEastOutFieldCloseWebview()
    } else {
      router.go(-1)
    }
  })
}

export const getLangKey = (lang: string) => {
  switch (lang) {
    case 'CN':
      return 'zh-cn'
    case 'EN':
      return 'en-us'
    default:
      return 'en-us'
  }
}
